import { render, staticRenderFns } from "./SocialMediaSelect.vue?vue&type=template&id=0cf5f4f8&"
import script from "./SocialMediaSelect.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports